import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import { Action, FlexTrackingInfo, sendDelayedTrackEvent } from "components/utility/analytics/FlexAnalyticsUtils";
import { EditorialWithLink } from "components/flexComponents/Content/factory/impl/editorials/EditorialWithLink";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialFlexModule } from "typings/microserviceModels/content-flex-module";

export class CardWithLinkEditorial extends EditorialBase {
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public generate(props: ContentProps) {
    const { analytics } = props;

    if (!this.editorial.items[0].media || this.editorial.items[0].media.length === 0) {
      return null;
    }

    const cardClicked = () => {
      const trackingInfo: FlexTrackingInfo = {
        moduleName: this.flexComponent.name,
        rfrr: (this.flexComponent.model as EditorialFlexModule).title.replace(/\s/g, ""),
        action: Action.CLICK
      };

      sendDelayedTrackEvent(trackingInfo, analytics);
    };

    const uitkClassNames = this.getEditorialItemClassName();

    return (
      <div
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
        className={`uitk-cell uitk-type-center Editorial all-cell-1-1 ${uitkClassNames}`}
        onClick={cardClicked}
        role="button"
      >
        <EditorialWithLink flexComponent={props.flexComponent} l10n={props.l10n} context={props.context} />
      </div>
    );
  }

  public getEditorialItemClassName = (): string =>
    "all-t-margin-three m-b-margin-three l-b-margin-three xl-b-margin-three";
}

export default CardWithLinkEditorial;
